iScreenWizard.factory('Faq', function ($q, Ajax) {

    var data = {};

    data.all = function(params) {
        if (typeof params === 'undefined') {
            params = {};
        }
        return $q(function (resolve, reject) {
            Ajax.get('faq', params).then(function (response) {
                var faqs = response.data;
                resolve(faqs);
            }, reject);
        });
    };

    data.get = function(id) {
        return $q(function (resolve, reject) {
            Ajax.get('faq/'+id).then(function (response) {
                var faq = response.data;
                resolve(faq);
            }, reject);
        });
    };

    return data;
});